
export default {
  name: 'MoleculeImageInfo'
}
